import { upperFirst } from 'lodash';
import { ChevronRight } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import SmallCaps from './SmallCaps';
import styles from './TopicBand.module.scss';

const LABEL_TONE = {
  default: 'band',
  alert: 'inverse',
  current: 'inverse',
  done: 'done',
  warn: 'warn',
};

const TopicBand = ({
  label,
  meta,
  tone = 'default',
  density = 'band',
  headingLevel,
  expanded,
  onToggle,
  className,
  children,
}) => {
  const group = density === 'group';
  const toggles = typeof onToggle === 'function';
  const Tag = toggles ? 'button' : 'div';
  return (
    <Tag
      {...(toggles ? { type: 'button', 'aria-expanded': !!expanded, onClick: onToggle } : {})}
      className={[
        styles.band,
        styles[tone],
        styles[`density${upperFirst(density)}`],
        toggles ? styles.toggle : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {toggles && (
        <ChevronRight
          size={14}
          aria-hidden="true"
          className={`${styles.chevron} ${expanded ? styles.chevronOpen : ''}`}
        />
      )}
      <SmallCaps
        as={toggles ? 'span' : (headingLevel ?? 'span')}
        size={group ? 'xs' : 'sm'}
        tone={group ? 'muted' : LABEL_TONE[tone]}
      >
        {label}
      </SmallCaps>
      {meta != null && meta !== false && meta !== '' && (
        <span className={`${styles.meta} ${styles[`meta${upperFirst(tone)}`]}`}>{meta}</span>
      )}
      {children}
    </Tag>
  );
};

TopicBand.propTypes = {
  label: PropTypes.node.isRequired,
  meta: PropTypes.node,
  tone: PropTypes.oneOf(['default', 'alert', 'current', 'done', 'warn']),
  density: PropTypes.oneOf(['band', 'card', 'group']),
  headingLevel: PropTypes.oneOf(['h3', 'h4']),
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default TopicBand;
